
module.exports = {
    Api_LocalURl:"https://refferal.bookofgatesofficial.com/"
}